import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import projectKeys from '@/api/queries/project/keyFactory';
import servicePlanKeys from '@/api/queries/service-plans/keyFactory';
import { graphql } from '@/gql';
import {
  CreateProjectForServicePlanPeriodInput,
  CreateProjectForServicePlanPeriodMutation as CreateProjectForServicePlanPeriodMutationResult,
} from '@/gql/graphql';

const CreateProjectForServicePlanPeriodMutation = graphql(`
  mutation CreateProjectForServicePlanPeriod(
    $input: CreateProjectForServicePlanPeriodInput!
  ) {
    createProjectForServicePlanPeriod(input: $input) {
      id
      publicId
    }
  }
`);

const useCreateProjectForServicePlanPeriod = (args?: {
  options?: UseMutationOptions<
    CreateProjectForServicePlanPeriodMutationResult,
    Error,
    CreateProjectForServicePlanPeriodInput
  >;
}) => {
  const queryClient = useQueryClient();
  const { onSuccess, ...restOptions } = args?.options ?? {};

  return useMutation({
    mutationFn: (input: CreateProjectForServicePlanPeriodInput) => {
      return gqlClient.request(CreateProjectForServicePlanPeriodMutation, {
        input,
      });
    },
    onSuccess: (data, variables, context) => {
      void queryClient.invalidateQueries({ queryKey: servicePlanKeys.all });
      void queryClient.invalidateQueries({ queryKey: projectKeys.all });
      onSuccess?.(data, variables, context);
    },
    ...restOptions,
  });
};

export default useCreateProjectForServicePlanPeriod;
